import { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { type OrderingContext } from '@order/features-ordering';

export const useNavigatePostOrder = () => {
  const router = useRouter();

  const navigatePostOrder = useCallback(
    (params: NavigatePostOrderParams) => {
      const { context } = params;

      const orderId = context.orderId || context.cart.orderId;

      router.dismissTo({ pathname: '/', params: { orderId } });
    },
    [router],
  );

  return { navigatePostOrder };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type NavigatePostOrderParams = {
  context: OrderingContext;
};
